const cancellations = new Set<() => void>();

export function registerModalCancellation(cancel: () => void) {
  cancellations.add(cancel);
  return () => {
    cancellations.delete(cancel);
  };
}

export function cancelPendingModals() {
  const pending = [...cancellations];
  cancellations.clear();
  for (const cancel of pending) cancel();
}
